import { createFileRoute } from "@tanstack/react-router";
import IRSForms from "@/pages/site/IRSForms";

export const Route = createFileRoute("/resources/irs-forms/")({
  component: () => <IRSForms />,
});
